import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/admin/roles";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListNoPagination() {
    return Repository.get(`${resource}?is_paginate=0`)
  },
  getRole(role_id) {
    return Repository.get(`${resource}/${role_id}`)
  },
  updateRole(role_id, payload) {
    return Repository.put(`${resource}/${role_id}`, payload)
  },
  createRole(payload) {
    return Repository.post(`${resource}`, payload)
  },
};
